import Vue from 'vue';
import VueRouter from 'vue-router';

export function useRouter() {
  return Vue['Router'] as VueRouter;
}
